import React from 'react';
import { AuthProvider } from './AuthContext';
import { ConfigProvider } from './ConfigContext';
import { BalanceProvider } from './BalanceContext';
import { ReportProvider } from './ReportContext';
import { TagProvider } from './TagContext';
import { VendorProvider } from './VendorContext';
import { IncomingInvoiceProvider } from './IncomingInvoiceContext';
import { LedgerProvider } from './LedgerContext';
import { AccountsProvider } from './AccountsContext';
import { ThemeProvider } from './ThemeContext';
import { JournalProvider } from './JournalContext';
import { FinderProvider } from './FinderContext';
import { AccountReportProvider } from './AccountReportContext';
import { BankingProvider } from './BankingContext';
import { SchoolProvider } from './SchoolContext';
import { FeesStudentProvider } from './FeesStudentContext';
import { FeesTransactionProvider } from './FeesTransactionContext';
import { FeesProfileProvider } from './FeesProfileContext';
import { FeesDefaulterProvider } from './FeesDefaulterContext';
import { FeesDiscountProvider } from './FeesDiscountContext';
import { VendorStatementProvider } from './VendorStatementContext';
import { OnlineSchoolFeesProvider } from './OnlineSchoolFeesContext';
import { GymProvider } from './Gym/GymContext';
import { GymCustomerProvider } from './Gym/GymCustomerContext';
import { GymInvoiceProvider } from './Gym/GymInvoiceContext';
import { CashFlowProvider } from './CashFlowContext';
import { StatProvider } from './StatContext';
import { ProjectReportProvider } from './ProjectReportContext';
import { PermissionProvider } from './PermissionContext';
import { WalletProvider } from './WalletContext';
import { ApprovalProvider } from './ApprovalContext';
import { SchWalletProfileProvider } from './SchWalletProfileContext';
import { SchWalletBalanceProvider } from './SchWalletBalanceContext';

const SuperStore = ({ children }) => {
    return (
        <AuthProvider>
            <ConfigProvider>
                <BalanceProvider>
                    <ReportProvider>
                    <CashFlowProvider>
                        <TagProvider>
                            <VendorProvider>
                                <IncomingInvoiceProvider>
                                    <LedgerProvider>
                                        <AccountsProvider>
                                            <JournalProvider>
                                                <ThemeProvider>
                                                    <FinderProvider>
                                                        <AccountReportProvider>
                                                            <BankingProvider>
                                                                <SchoolProvider>
                                                                    <FeesStudentProvider>
                                                                        <FeesTransactionProvider>
                                                                            <FeesProfileProvider>
                                                                                <FeesDefaulterProvider>
                                                                                    <FeesDiscountProvider>
                                                                                        <VendorStatementProvider>
                                                                                            <OnlineSchoolFeesProvider>
                                                                                                <GymProvider>
                                                                                                    <GymCustomerProvider>
                                                                                                        <GymInvoiceProvider>
                                                                                                            <StatProvider>
                                                                                                                <ProjectReportProvider>
                                                                                                                    <PermissionProvider>
                                                                                                                        <WalletProvider>
                                                                                                                            <ApprovalProvider>
                                                                                                                                <SchWalletProfileProvider>
                                                                                                                                    <SchWalletBalanceProvider>{children}</SchWalletBalanceProvider>
                                                                                                                                </SchWalletProfileProvider>
                                                                                                                            </ApprovalProvider>
                                                                                                                        </WalletProvider>
                                                                                                                    </PermissionProvider>
                                                                                                                </ProjectReportProvider>
                                                                                                            </StatProvider>
                                                                                                        </GymInvoiceProvider>
                                                                                                    </GymCustomerProvider>
                                                                                                </GymProvider>
                                                                                            </OnlineSchoolFeesProvider>
                                                                                        </VendorStatementProvider>
                                                                                    </FeesDiscountProvider>
                                                                                </FeesDefaulterProvider>
                                                                            </FeesProfileProvider>
                                                                        </FeesTransactionProvider>
                                                                    </FeesStudentProvider>
                                                                </SchoolProvider>
                                                            </BankingProvider>
                                                        </AccountReportProvider>
                                                    </FinderProvider>
                                                </ThemeProvider>
                                            </JournalProvider>
                                        </AccountsProvider>
                                    </LedgerProvider>
                                </IncomingInvoiceProvider>
                            </VendorProvider>
                        </TagProvider>
                    </CashFlowProvider>
                    </ReportProvider>
                </BalanceProvider>
            </ConfigProvider>
        </AuthProvider>
        
    );
};

export default SuperStore;